import { Controller } from "@hotwired/stimulus";

/*
 * Al navegar por el sitio y llegar a ciertas secciones, se van
 * activando ítems del menú.
 *
 * Para eso configuramos un IntersectionObserver en todo el documento y
 * a medida que van apareciendo secciones actualizamos el menú.
 */
export default class extends Controller {
  static targets = ["section"];

  connect() {
    this.scrollSectionListener = this._scrollSectionListener.bind(this);

    window.addEventListener("scroll:section", this.scrollSectionListener);
  }

  disconnect() {
    window.removeEventListener("scroll:section", this.scrollSectionListener);
  }

  _scrollSectionListener(event) {
    this.update(event.detail.id);
  }

  update(id) {
    console.debug(id);
    for (const illustrationEl of document.querySelectorAll(
      "[data-scroll-illustration]"
    )) {
      illustrationEl.style.display = "none";
    }
    const illustrationEl = document.querySelector(
      `[data-scroll-illustration="${id}"]`
    );
    if (illustrationEl) illustrationEl.style.display = "block";
  }
}
